// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___1_bLi","container_1":"container_1___2dXbA","container_2":"container_2___37Fdr"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Category/styles.module.scss
// module id = 729
// module chunks = 0